<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <users-clear></users-clear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UsersClear from './users/UsersClear';

    export default {

        components: {
            UsersClear
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.users'),
                        route: '/astral/ui/accounts/users'
                    },
                    {
                        name: this.$t('common.outdated'),
                    },
                ]
            }
        },
    }
</script>
